import { useEffect } from "react";
import { t } from "i18next";
// @ts-expect-error this package has no published types.
import Feedback from "@betahuhn/feedback-js";

export const useFeedback = (): void => {
  const feedbackButtonId = "feedback-btn";

  useEffect(() => {
    const options = {
      endpoint: import.meta.env.VITE_API_BASE_URL + "/feedback",
      id: feedbackButtonId,
      emailField: false,
      primary: "#0399FF",
      failedMessage: t("feedback.error"),
    };

    try {
      const feedbackButton = document.getElementById("feedback-btn");

      if (!feedbackButton) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        new Feedback(options).renderButton();
      }
    } catch (error: unknown) {
      console.error("Error while initializing feedback button", error);
    }

    return (): void => {
      document.getElementById("feedback-btn")?.remove();
    };
  }, []);
};
